module.exports = __webpack_public_path__ + "static/media/healthy_diet.c92ba012.jpg";